import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { CancelTokenSource } from 'axios';
import UpsertDoctorForm from 'components/doctors/UpsertDoctorForm';
import CheckBox from 'components/final-form/CheckBox';
import DatePicker from 'components/final-form/DatePicker';
import {
  DropdownOption,
  mapToDropdownOptionArray,
  mapToDropdownOptionArrayWithTextGetter,
  stringArrayToDropdownOptionArray
} from 'components/final-form/dropdownUtils';
import Input from 'components/final-form/Input';
import RadioGroup from 'components/final-form/RadioGroup';
import { generateRadioButtonOptionsFromEnum } from 'components/final-form/radioUtils';
import Select from 'components/final-form/Select';
import { selectInput } from 'components/final-form/SelectInput';
import TextArea from 'components/final-form/TextArea';
import TimeInput from 'components/final-form/TimeInput';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import PxGrid from 'components/layout/PxGrid';
import ToolbarButton from 'components/layout/ToolbarButton';
import { MandateConsumerRenderProps, withMandateContext } from 'components/MandateContext';
import UpsertOrderItemInstance from 'components/patient-entry/bookings-table/UpsertOrderItemInstance';
import { TransitionMode } from 'components/patient-entry/bookings-table/VaccinationTransitionForm';
import {
  PatientCentralConsumerRenderProps,
  withPatientCentralContext
} from 'components/patient-entry/PatientCentralContext';
import {
  PatientCentralRefDataConsumerRenderProps,
  withPatientCentralRefDataContext
} from 'components/patient-entry/PatientCentralRefDataContext';
import { CardData, CardReaderState } from 'components/patient/upsert/PatientCardData';
import UpsertPatient from 'components/patient/upsert/UpsertPatient';
import { FormState } from 'final-form';
import createDecorator from 'final-form-calculate';
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { Field, Form as FinalForm, FormRenderProps, FormSpy } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Icon, Loader, Message, Modal, Popup, RadioProps } from 'semantic-ui-react';
import { getAllCountries } from 'services/countryServices';
import { getRapidTestCodes } from 'services/covidProductsServices';
import { findDoctorById, searchDoctorsForInput } from 'services/doctorServices';
import axios from 'services/http';
import { getTestCheckInData, testCheckIn } from 'services/interventionBookingServices';
import { getInterventionPrice } from 'services/interventionPriceServices';
import { getAllLanguages } from 'services/languageServices';
import {
  checkPatientHealthCardData,
  findPatientById,
  getPatientData,
  updatePatientDataFromHealthCard
} from 'services/patientServices';
import { fetchAllProducts } from 'services/productServices';
import styled from 'styled-components';
import {
  CovidTestSampleMethod,
  InterventionBookingStatus,
  InterventionExternalCode,
  PaymentMethod,
  Urgency
} from 'ts-types/api.enums';
import {
  CompleteVaccinationBookingRequestDto,
  CountryDto,
  DoctorDto,
  HealthCardDataDto,
  InterventionAvailabilityDetailsDto,
  InterventionTestBookingSearchResult,
  LanguageDto,
  PatientDataResponseDto,
  PatientDto,
  ProductDto,
  RapidTestProduct,
  TestCheckInDto,
  TreatmentBookingUpdateRequest,
  UpsertDoctorDto,
  UpsertPatientDto
} from 'ts-types/api.types';
import { isValidBarcode } from 'utils/barcodeUtils';
import { ChromeExtensionStatus, getChromeExtensionStatus, readHealthCard } from 'utils/chomeExtensionUtils';
import { ISO_DATE_FORMAT, isoToDisplayDate, toIsoDateString } from 'utils/dateUtils';
import { errorUtils } from 'utils/errorUtils';
import { noop } from 'utils/functionUtils';
import { getSampleMethods, isLabTest, isTestKitCodeOptional } from 'utils/interventionUtils';
import { IndexSignature } from 'utils/praxTypes';
import {
  ccdValidator,
  composeValidators,
  emailValidator,
  required,
  twintTransactionIdValidator
} from 'utils/validatorUtils';


const CheckInOutDiv = styled.div`

  min-width: 35rem;

  .header {
    margin-bottom: 0.7rem;
    padding: 0.5rem 0.65rem 1rem;
    font-size: 1.2rem;
    font-weight: bold;
  }

  .form-content {
    min-height: 17rem;

    & .ui.grid {
      margin: 0;
    }

    & .ui.grid > * {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }

    .ui.grid > .row > .column.no-padding {
      padding-left: 0;
      padding-right: 0;
    }

    label {
      font-weight: bold;
    }

    .radio-group {
      label {
        margin-right: 1rem;
        font-weight: unset;
      }
    }

    & .doctor-email-warning {
      color: #8a7305;
      margin-top: .2rem;
    }
  }

  .actions-row {

    margin-top: 1rem;

    button {
      display: inline-block;
      margin-right: 0.5rem;
    }
  }

  .field-error {
    padding: 0.2rem 0;
    color: darkred;
    font-size: 0.975rem;
  }

  .submit-error {
    color: darkred;
    display: inline-block;
  }

  .submit-warn, .doctor-email-warn {
    color: #8a7305;
    display: inline-block;
  }

  .doctor-email-warn {
    margin-top: .2rem;
  }

  .inkasso-warn {
    padding-top: 0.3rem;
    display: inline-block;
    color: #8a7305;

    i.icon {
      color: #8a7305 !important;
    }
  }

  .patient-data-container {
    i.icon {
      margin-left: .5rem;
      cursor: pointer;
    }
  }

  .email-field {
    padding: 0.3rem 0;
  }

  .different-data {
    color: #794b02;
  }

  .ui.compact.button.update-btn {
    margin-left: 8rem;
  }
`;

const StyledIcon = styled.span`
  float: right;
`;

const InfoDiv = styled.div`
  & .info-message {
    margin-top: 2rem;
    min-height: 105px;
  }

  & .info-message .download-link {
    margin-top: 1.5rem;
  }

  & .actions .button:first-child {
    margin-left: 0;
  }
`;

const RapidTestCodeRowStyles = {
  marginBottom: "1rem",
  borderBottom: "1px solid rgba(34,36,38,.15)",
  paddingBottom: "1.5rem"
}

const RowStyles = {
  marginTop: "1rem",
  paddingTop: "1.5rem",
  borderTop: "1px solid rgba(34,36,38,.15)"
}

interface CheckHealthCardData {
  name: string;
  firstName: string;
  birthDate: string;
  guarantorName: string;
}

interface TestFormValues {
  changeEmail: boolean;
  companyEmail: string;
  testkitCode?: string;
  testSampleMethod?: CovidTestSampleMethod;
  rapidTestCode?: string;
  expectedResultDate?: string;
  expectedResultTime?: string;
  referralDoctorId?: number;
  urgency: Urgency;
  productId: string;
  orderItemComponentIds: number[];
  inkasso: PaymentMethod;
  creditCardDigits?: string;
  twintTransactionId?: string;
  generateCertificate: boolean;
  generateReport: boolean;
  remarks?: string;
}

const validBarCode = (value: string) => {

  if (!value) {
    return
  }

  const validBarcode = isValidBarcode(value);
  return validBarcode ? undefined : "invalidCode";
};

interface Props extends MessageSourceProps,
    AuthConsumerRenderProps,
    PatientCentralRefDataConsumerRenderProps,
    PatientCentralConsumerRenderProps,
    MandateConsumerRenderProps {

  bookingInTransition: InterventionTestBookingSearchResult,
  onCheckInSave: (bookingId: number, status: InterventionBookingStatus | undefined) => void
  onCheckOutSave: (bookingId: number, request: CompleteVaccinationBookingRequestDto) => void
  onCancel: () => void
}

interface State {
  transitionMode: TransitionMode;

  requiredDataLoaded: boolean;
  patientData?: PatientDataResponseDto;
  testCheckInData?: TestCheckInDto;
  sampleMethods: RadioProps[];
  urgencyOptions: DropdownOption[];
  products: ProductDto[];
  productOptions: DropdownOption[];
  paymentMethodOptions: DropdownOption[];

  patientId?: number,
  patient?: UpsertPatientDto,
  patientModalOpen: boolean,
  patientLoading: boolean,

  countries: Array<CountryDto>,
  languages: Array<LanguageDto>,

  referralDoctorMap: IndexSignature,
  referralDoctorOptions: DropdownOption[],

  healthCardPopupOpen: boolean;
  healthCardPopupStatus: CardReaderState;
  updateSuccess: boolean;

  healthCardCheck: boolean;
  checkHealthCardData?: CheckHealthCardData;

  availability?: InterventionAvailabilityDetailsDto;

  healthCardRead: boolean;

  productId?: string;
  interventionPriceInsurance?: number;
  interventionPricePatient?: number;

  orderItemEditModalOpen: boolean;

  rapidTestCodeOptions: DropdownOption[];

  submitError?: string;
  submitWarning?: string;

  missingDoctorEmail: boolean;
  doctor?: UpsertDoctorDto,
  doctorId?: number,
  editDoctorModalOpen: boolean;
}

class TestTransitionForm extends Component<Props, State> {

  cancelTokenSource: CancelTokenSource = axios.CancelToken.source();

  initialValues: Partial<TestFormValues> = {};

  constructor(props: Props) {
    super(props);

    const booking = props.bookingInTransition;

    const intervention = props.getInterventionById(booking.interventionId);
    const externalCode = intervention && intervention.externalCode;
    const pcrIndividualTest = externalCode === InterventionExternalCode.PCR_SALIVA_TEST_INDIVIDUAL_TEST;
    const rapidTest = externalCode === InterventionExternalCode.RAPID_SALIVA_TEST;
    const questionTest = externalCode === InterventionExternalCode.CLINICAL_QUESTIONS_TEST;
    const hpvTest = externalCode === InterventionExternalCode.HPV_TEST;
    const chlamydiaTest = externalCode === InterventionExternalCode.CHLAMYDIA_TEST;
    const trichomoniasisTest = externalCode === InterventionExternalCode.TRICHOMONIASIS_TEST;
    const hepatitisBTest = externalCode === InterventionExternalCode.HEPATITIS_B_TEST;
    const bloodTest = externalCode === InterventionExternalCode.QUANTITY_TEST
        || externalCode === InterventionExternalCode.ORDER_ITEM_TEST;

    let testSampleMethod = booking.testSampleMethod ? CovidTestSampleMethod[booking.testSampleMethod] : undefined;
    if (!testSampleMethod && !questionTest) {
      if (hpvTest || chlamydiaTest || trichomoniasisTest) {
        testSampleMethod = CovidTestSampleMethod.VAGINAL_SWAB;
      } else if (pcrIndividualTest) {
        testSampleMethod = CovidTestSampleMethod.SALIVA;
      } else if (hepatitisBTest || bloodTest) {
        testSampleMethod = CovidTestSampleMethod.BLOOD_SERUM;
      } else {
        testSampleMethod = CovidTestSampleMethod.NASAL_SWAB;
      }
    }

    let rapidTestCode = booking.rapidTestCode;
    const locationId = booking.locationId;
    if (rapidTest && !rapidTestCode && locationId) {
      const resourceDto = props.resources.find(res => res.id === locationId);
      rapidTestCode = resourceDto && resourceDto.rapidTestCode ? resourceDto.rapidTestCode : rapidTestCode;
    }

    this.initialValues = {
      changeEmail: false,
      testkitCode: booking.testKitCode,
      rapidTestCode,
      testSampleMethod: testSampleMethod
    }

    const transitionMode = "checkIn";
    // const transitionMode = booking.status === InterventionBookingStatus.EXECUTED
    //     ? "checkIn" : "checkOut";

    const testSampleMethods = externalCode ? getSampleMethods(InterventionExternalCode[externalCode]) : [];

    const sampleMethodProps = generateRadioButtonOptionsFromEnum(
        Object.values(testSampleMethods), "covidTestSampleMethod", props.getMessage);

    const urgencyOptions = stringArrayToDropdownOptionArray(
        Object.values(Urgency), props.getMessage, "enum.urgency");

    const paymentMethodOptions = stringArrayToDropdownOptionArray(
        Object.values(PaymentMethod), props.getMessage, "enum.paymentMethod");

    this.state = {
      transitionMode,

      sampleMethods: sampleMethodProps,
      urgencyOptions: urgencyOptions,
      products: [],
      productOptions: [],
      paymentMethodOptions: paymentMethodOptions,

      referralDoctorMap: [],
      referralDoctorOptions: [],

      requiredDataLoaded: false,

      healthCardPopupOpen: false,
      updateSuccess: false,
      healthCardCheck: true,
      healthCardPopupStatus: CardReaderState.INITIAL,

      healthCardRead: false,

      rapidTestCodeOptions: [],

      orderItemEditModalOpen: false,

      patientModalOpen: false,
      patientLoading: false,

      languages: [],
      countries: [],

      missingDoctorEmail: false,
      editDoctorModalOpen: false
    };
  }

  componentDidMount() {
    this.loadRequiredData(this.state);
  }

  loadRequiredData = async (state: State) => {
    const booking = this.props.bookingInTransition;
    try {

      const patientData = await getPatientData(booking.patientId, this.cancelTokenSource);

      let availability = undefined;
      // if (this.state.transitionMode === "checkOut") {
      //   availability = await getInterventionAvailabilityForInterventionBooking(
      //       booking.bookingId, this.cancelTokenSource);
      //   this.initialValues = {
      //   }
      // }

      this.initialValues.companyEmail = patientData.companyEmail;

      let testCheckInData: TestCheckInDto | undefined = undefined;

      let languages: LanguageDto[] = [];
      let countries: CountryDto[] = [];
      let products: ProductDto[] = [];
      let rapidTestCodes: RapidTestProduct[] = [];
      if (this.state.transitionMode === "checkIn") {
        [testCheckInData, languages, countries, rapidTestCodes, products] =
            await Promise.all([
              getTestCheckInData(booking.bookingId, this.cancelTokenSource),
              getAllLanguages(this.cancelTokenSource),
              getAllCountries(this.cancelTokenSource),
              getRapidTestCodes(this.cancelTokenSource),
              fetchAllProducts(false, this.cancelTokenSource)
            ]);

        products = products.filter(product =>
            (product.active && !product.systemProduct)
            || (testCheckInData && product.id === testCheckInData.productId));

      }

      this.initialValues = {
        ...this.initialValues,
        orderItemComponentIds: [],
        testkitCode: testCheckInData ? testCheckInData.testKitCode : undefined,
        creditCardDigits: testCheckInData ? testCheckInData.creditCardDigits : undefined,
        twintTransactionId: testCheckInData ? testCheckInData.twintTransactionId : undefined,
        remarks: testCheckInData ? testCheckInData.remarks : undefined
      }

      let sampleMethods = state.sampleMethods;

      if (testCheckInData) {

        const productId = testCheckInData.productId;
        const product = productId ? products.find(product => product.id === productId) : undefined;
        this.initialValues.productId = productId;

        const orderItem = testCheckInData.orderItem;
        if (orderItem) {
          this.initialValues.orderItemComponentIds = orderItem.components.map(panel => panel.id);
        }

        if (testCheckInData.intervention && !_.isNil(testCheckInData.intervention.sampleMethods)) {
          const interventionSampleMethods = testCheckInData.intervention.sampleMethods;
          sampleMethods = generateRadioButtonOptionsFromEnum(
              Object.values(interventionSampleMethods), "covidTestSampleMethod", this.props.getMessage);

          if (!this.initialValues.testSampleMethod && sampleMethods.length === 1) {
            this.initialValues.testSampleMethod = sampleMethods[0].value as CovidTestSampleMethod;
          }
        }

        if (testCheckInData.referralDoctorId) {
          this.initialValues.referralDoctorId = testCheckInData.referralDoctorId;
          await this.fetchSpecificReferralDoctor(testCheckInData.referralDoctorId);
        }

        if (testCheckInData.testSampleMethod) {
          this.initialValues.testSampleMethod = CovidTestSampleMethod[testCheckInData.testSampleMethod];
        }
        if (testCheckInData.urgency) {
          this.initialValues.urgency = Urgency[testCheckInData.urgency];
        } else if (product && product.urgency) {
          this.initialValues.urgency = Urgency[product.urgency];
        }

        if (testCheckInData.expectedResultDate && testCheckInData.expectedResultTime) {
          this.initialValues.expectedResultDate = testCheckInData.expectedResultDate;
          this.initialValues.expectedResultTime = testCheckInData.expectedResultTime;
        } else if (product && product.resultAfter) {
          this.initialValues.expectedResultDate = moment().format(ISO_DATE_FORMAT);
          this.initialValues.expectedResultTime = moment()
              .add(product.resultAfter, 'hours')
              .format("HH:mm");
        }

        if (testCheckInData.inkasso) {
          this.initialValues.inkasso = PaymentMethod[testCheckInData.inkasso];
        }

        this.initialValues.generateCertificate = product ? product.generateCertificate : false;
        this.initialValues.generateReport = product ? product.generateReport : false;

        products = products.filter(product => product.externalCode === testCheckInData!.externalCode
            && (!product.resourceIds
                || !testCheckInData!.locationId
                || product.resourceIds.length === 0
                || product.resourceIds.includes(`${testCheckInData!.locationId}`)))
      }

      const lang = this.props.language;
      const getProductDescription = (product: ProductDto) => {
        if (lang === 'en') {
          return product.descriptionEn || product.description;
        } else if (lang === 'fr') {
          return product.descriptionFr || product.description;
        } else if (lang === 'it') {
          return product.descriptionIt || product.description;
        }
        return product.description;
      }

      const productOptions = mapToDropdownOptionArrayWithTextGetter(
          products, product => getProductDescription(product));

      const rapidTestCodeOptions = mapToDropdownOptionArray(
          rapidTestCodes, "display", "code", "code");

      this.setState({
        patientData,
        testCheckInData,
        availability,
        products,
        productOptions,
        languages,
        countries,
        sampleMethods,
        rapidTestCodeOptions
      });

    } finally {
      this.setState({
        requiredDataLoaded: true
      });
    }
  };

  fetchSpecificReferralDoctor = async (referralDoctorId: number) => {
    try {
      const referralDoctor = await findDoctorById(referralDoctorId, this.cancelTokenSource);

      const doctorName = referralDoctor.name;
      const doctorFirstName = referralDoctor.firstName ? referralDoctor.firstName : "";
      const doctorCity = referralDoctor.city;
      const doctorStreet = referralDoctor.street ? referralDoctor.street : "";

      const referralDoctorOption: DropdownOption = {
        key: referralDoctorId,
        text: `${doctorName}, ${doctorFirstName}, ${doctorCity}, ${doctorStreet}`,
        value: referralDoctorId
      };

      const referralDoctorDto: DoctorDto = {
        ...referralDoctor,
        id: referralDoctorId
      };

      this.setState({
        referralDoctorMap: _.keyBy([referralDoctorDto], "id"),
        referralDoctorOptions: [referralDoctorOption],
        missingDoctorEmail: !referralDoctor.email
      });
    } catch (e) {

    }

  };

  searchDoctors = (search: string): Promise<DoctorDto[]> => {
    return searchDoctorsForInput(search, this.cancelTokenSource, 75);
  };

  mapDoctors = (doctors: DoctorDto[]): DropdownOption[] => {

    this.setState({
      referralDoctorMap: _.keyBy(doctors, "id")
    });

    return doctors.map(doctor => ({
      key: doctor.id,
      text: `${doctor.name}, ${doctor.firstName ? doctor.firstName : ""}, ${doctor.city}, ${doctor.street ? doctor.street : ""}`,
      value: doctor.id
    }));
  };

  triggerUpdatePatientFromHealthCard = async (patientId: number) => {
    const {healthCardCheck} = this.state;
    const {config} = this.props;

    this.setState({
      healthCardPopupOpen: true,
      healthCardPopupStatus: CardReaderState.INITIAL
    });

    const extStatus = await getChromeExtensionStatus(config);

    if (ChromeExtensionStatus.NO_EXTENSION === extStatus) {
      this.setHealthCardReaderStatus(CardReaderState.NO_EXTENSION);
    } else if (ChromeExtensionStatus.OUTDATED_EXTENSION === extStatus) {
      this.setHealthCardReaderStatus(CardReaderState.OUTDATED_EXTENSION);
    } else if (ChromeExtensionStatus.NO_HOST_APPLICATION === extStatus) {
      this.setHealthCardReaderStatus(CardReaderState.NO_HOST_APPLICATION);
    } else if (ChromeExtensionStatus.OUTDATED_HOST_APP === extStatus) {
      this.setHealthCardReaderStatus(CardReaderState.OUTDATED_HOST_APP);
    } else if (ChromeExtensionStatus.OK === extStatus) {

      const cardReaderResponse: any = await readHealthCard();

      const payload = cardReaderResponse.payload;
      if (cardReaderResponse.status === 'ERROR' && payload.errorCode === "NO_PATIENT_DATA") {
        this.setHealthCardReaderStatus(CardReaderState.NO_CARD);
      } else if (cardReaderResponse.status === 'ERROR') {
        this.setHealthCardReaderStatus(CardReaderState.ERROR);
      } else if (cardReaderResponse.status === 'RESULT') {
        const responseCardData = payload;

        const cardData: CardData = {
          name: responseCardData.lastName,
          firstName: responseCardData.firstName,
          birthDate: responseCardData.dateOfBirth,
          ahvNumber: responseCardData.insuranceNumber,
          sex: responseCardData.gender === "1" ? 1 : 0,
          country: responseCardData.issuingState,
          guarantorName: responseCardData.nameOfTheInstitution,
          institutionId: responseCardData.identificationNumberOfTheInstitution,
          cardId: responseCardData.insuredPersonNumber,
          expiryDate: responseCardData.expiryDate
        };

        const request: HealthCardDataDto = {
          patientId: patientId,
          name: cardData.name,
          firstName: cardData.firstName,
          bagNumber: cardData.institutionId,
          ahvNumber: cardData.ahvNumber,
          healthCardNumber: cardData.cardId,
          dateOfBirth: cardData.birthDate,
          expiryDate: cardData.expiryDate,
          gender: responseCardData.gender,
          guarantorName: cardData.guarantorName
        };

        let check = true;

        if (healthCardCheck) {
          check = await checkPatientHealthCardData(request, this.cancelTokenSource);
          this.setState({
            healthCardCheck: check
          });
        }

        if (!check) {
          this.setState({
            checkHealthCardData: {
              name: request.name,
              firstName: request.firstName,
              birthDate: request.dateOfBirth,
              guarantorName: request.guarantorName
            },
            healthCardPopupOpen: false
          })
        }

        if (check) {

          const patientData = await updatePatientDataFromHealthCard(request, this.cancelTokenSource);

          if (patientData) {

            this.setState({
              patientData: patientData,
              updateSuccess: true
            });
          }

          this.setState({
            healthCardPopupOpen: false,
            healthCardCheck: true,
            checkHealthCardData: undefined
          });
        }
      }
    }
  }

  setHealthCardReaderStatus(status: CardReaderState) {
    this.setState({
      healthCardPopupStatus: status
    });
  }

  closeUpdateFromHealthCardPopup = () => {
    this.setState({
      healthCardPopupOpen: false
    });
  };

  parseCreditCardDigitsInput = (value: any) => {
    if (!value || value.length < 5) {
      return value;
    } else {
      return value.slice(0, 4);
    }
  };

  parseTwintTransactionIdDigitsInput = (value: any) => {
    if (!value || value.length < 17) {
      return value;
    } else {
      return value.slice(0, 16);
    }
  };

  handleSubmit = (values: Partial<TestFormValues>) => {
    const {transitionMode, healthCardRead} = this.state;

    if (transitionMode === "checkIn" && !healthCardRead) {
      this.setState({
        healthCardRead: true,
        submitWarning: "patientCentral.checkOut.error.healthCardNotRead"
      });
      return;
    }

    this.onSave(values);
  }

  onSave = async (values: Partial<TestFormValues>) => {
    const {bookingInTransition, onCheckInSave, options} = this.props;
    const {transitionMode} = this.state;

    const bookingId = bookingInTransition.bookingId;

    if (transitionMode === "checkIn") {
      try {

        const foundProduct = values.productId ? this.state.products.find(product => product.id === values.productId) : undefined;
        const includeExpectedDateTime = foundProduct && foundProduct.resultAfter && values.expectedResultDate;

        const request: TreatmentBookingUpdateRequest = {
          bookingId: bookingInTransition.bookingId,
          companyEmail: values.changeEmail ? values.companyEmail : undefined,
          testkitCode: values.testkitCode!,
          testSampleMethod: values.testSampleMethod!,
          rapidTestCode: values.rapidTestCode,
          referralDoctorId: values.referralDoctorId,
          urgency: values.urgency!,
          productId: values.productId,
          orderItemPanelIds: values.orderItemComponentIds || [],
          expectedResultDate: includeExpectedDateTime ? values.expectedResultDate : undefined,
          expectedResultTime: includeExpectedDateTime ? values.expectedResultTime : undefined,
          cashAmount: this.state.interventionPricePatient,
          inkasso: values.inkasso!,
          creditCardDigits: values.creditCardDigits,
          twintTransactionId: values.twintTransactionId,
          generateCertificate: values.generateCertificate!,
          generateReport: values.generateReport!,
          remarks: values.remarks,
          treaterId: options.currentTreater.id
        }

        await testCheckIn(request, this.cancelTokenSource);
        onCheckInSave(bookingId, undefined);
      } catch (e) {
        this.handleError(e);
        return;
      }
    }
  };

  handleError = (error: any) => {
    const knownErrors: Array<string> = [
      errorUtils.invalidBarcode,
      errorUtils.barcodeAlreadyExists
    ];

    let errorMessage = "error.general";

    if (error.response && error.response.data) {
      const violations: Array<any> = error.response.data.violations;
      if (violations && violations.length > 0) {
        violations.forEach(violation => {
          if (knownErrors.includes(violation.errorCode)) {
            errorMessage = `error.${violation.errorCode}`;
          }
        });
      }
    }

    this.setState({
      submitWarning: undefined,
      submitError: errorMessage
    });
  };

  onFormChange = (formState: FormState) => {

    const values = formState.values as TestFormValues;

    const productIdState = this.state.productId;
    const productId = values.productId;
    if (productId && productId !== productIdState) {
      this.setState({
        interventionPricePatient: undefined,
        interventionPriceInsurance: undefined,
        productId: productId
      });
      getInterventionPrice(productId, toIsoDateString(moment()), this.cancelTokenSource)
          .then(result => {
            const privateTariffInvoices = result.invoices.filter(inv => inv.privateTariff);
            if (privateTariffInvoices) {
              const totalAmountPrivateTariff = privateTariffInvoices.reduce(
                  (total, invoice) => total + invoice.amount, 0);

              this.setState({interventionPricePatient: totalAmountPrivateTariff});
            }

            const insuranceInvoices = result.invoices.filter(inv => !inv.privateTariff);
            if (insuranceInvoices) {
              const totalAmountInsurance = insuranceInvoices.reduce(
                  (total, invoice) => total + invoice.amount, 0);

              this.setState({interventionPriceInsurance: totalAmountInsurance});
            }
          })
          .catch(noop);
    }
  }

  render = () => {

    const {
      requiredDataLoaded
    } = this.state;

    if (!requiredDataLoaded) {
      return <PxGrid>
        <Grid.Row>
          <Grid.Column width={16} textAlign="center">
            <Loader size="medium" active/>
          </Grid.Column>
        </Grid.Row>
      </PxGrid>
    }

    return <React.Fragment>
      <FinalForm
          onSubmit={(values) => this.handleSubmit(values)}
          initialValues={this.initialValues}
          decorators={[this.productDecorator]}
          subscription={{pristine: true, submitting: true, values: true}}
          render={this.renderForm}
      />
      {this.renderUpsertPatient()}
      {this.renderUpsertDoctorModal()}
    </React.Fragment>
  }

  isNoShowProduct = (product: ProductDto | undefined): boolean => {
    return product ? product.statusAfterCheckIn === InterventionBookingStatus.CANCELLED : false;
  }

  productDecorator = createDecorator({
    field: "productId",
    updates: (value, name, allValues?: Partial<TestFormValues>) => {
      const {bookingInTransition} = this.props;
      if (allValues && allValues.productId) {

        const selectedProduct = this.state.products.find(product => product.id === allValues.productId);
        let invoicePrivate = true;
        if (selectedProduct) {

          const noShowProduct = this.isNoShowProduct(selectedProduct);
          const productItems = selectedProduct.productItems;
          invoicePrivate = noShowProduct || productItems.map(item => item.cashOptions).includes(true);

          let expectedResultDate = undefined;
          let expectedResultTime = undefined;

          if (!bookingInTransition.expectedResultDate) {
            if (selectedProduct.resultAfter) {
              expectedResultDate = moment().format(ISO_DATE_FORMAT);
              expectedResultTime = moment().add(selectedProduct.resultAfter, 'hours').format("HH:mm");
            }
          } else {
            if (allValues.expectedResultDate) {
              expectedResultDate = allValues.expectedResultDate;
              expectedResultTime = allValues.expectedResultTime;
            }
          }

          let inkasso = !invoicePrivate && productItems.length ? PaymentMethod.INVOICE_GUARANTOR : allValues.inkasso;
          if (invoicePrivate && noShowProduct) {
            inkasso = PaymentMethod.INVOICE_PATIENT;
          } else if (invoicePrivate && inkasso === PaymentMethod.INVOICE_GUARANTOR) {
            inkasso = undefined;
          }

          return {
            ['inkasso']: inkasso,
            ['generateCertificate']: selectedProduct.generateCertificate,
            ['generateReport']: selectedProduct.generateReport,
            ['urgency']: selectedProduct.urgency ? Urgency[selectedProduct.urgency] : undefined,
            ['expectedResultDate']: expectedResultDate,
            ['expectedResultTime']: expectedResultTime
          };
        }
      }

      return {};
    }
  })

  renderForm = ({form, handleSubmit, values}: FormRenderProps): React.ReactNode => {

    const {bookingInTransition, getInterventionById, getMessage} = this.props;
    const {
      testCheckInData,
      transitionMode,
      sampleMethods,
      urgencyOptions,
      productOptions,
      products,
      rapidTestCodeOptions,
      referralDoctorOptions,
      referralDoctorMap,
      paymentMethodOptions,
      healthCardPopupOpen,
      checkHealthCardData,
      healthCardCheck,
      interventionPricePatient,
      interventionPriceInsurance,
      updateSuccess
    } = this.state;

    const patientData = this.state.patientData!;

    const inputChannel = bookingInTransition.inputChannel;
    const inputChannelDisplay = getMessage(`enum.interventionBookingInputChannel.${inputChannel}`);

    const isCheckIn = transitionMode === 'checkIn';

    const showCreditCardDigits = values && values.inkasso === PaymentMethod.CREDIT_CARD;
    const showTwintTransactionId = values && values.inkasso === PaymentMethod.TWINT;

    const inkassoWarning = values.inkasso === PaymentMethod.CASH || values.inkasso === PaymentMethod.INVOICE_PATIENT;
    const disabledInkasso = !values.productId && products.length;

    const foundProduct = values.productId ? products.find(product => product.id === values.productId) : undefined;
    let invoicePrivate: boolean | undefined = undefined
    if (foundProduct) {
      invoicePrivate = foundProduct.freeProduct
          || foundProduct.productItems.map(item => item.cashOptions).includes(true);
    }
    const finalStates = [InterventionBookingStatus.COMPLETED, InterventionBookingStatus.CANCELLED];
    const testKitCodeHidden = foundProduct
        && finalStates.includes(InterventionBookingStatus[foundProduct.statusAfterCheckIn]);

    const showExpectedDateTime = foundProduct && foundProduct.resultAfter;

    const freeProduct = foundProduct ? foundProduct.freeProduct : undefined;
    const noShowProduct = this.isNoShowProduct(foundProduct);

    let filteredPaymentMethods: DropdownOption[] = paymentMethodOptions;
    if (invoicePrivate && foundProduct && foundProduct.productItems.length) {
      filteredPaymentMethods = paymentMethodOptions.filter(pm => pm.value !== PaymentMethod.INVOICE_GUARANTOR);
    } else if (!invoicePrivate && foundProduct && foundProduct.productItems.length) {
      filteredPaymentMethods = paymentMethodOptions.filter(pm => pm.value === PaymentMethod.INVOICE_GUARANTOR);
    }

    const disabledExpResDateBefore = bookingInTransition.appointmentDate
        && new Date(bookingInTransition.appointmentDate);

    const intervention = getInterventionById(bookingInTransition.interventionId);
    const externalCode = intervention && intervention.externalCode;
    const rapidTest = externalCode === InterventionExternalCode.RAPID_SALIVA_TEST;
    const questionTest = externalCode === InterventionExternalCode.CLINICAL_QUESTIONS_TEST;
    const labTest = externalCode && isLabTest(InterventionExternalCode[externalCode]);

    const testkitCodeOptional =
        externalCode && isTestKitCodeOptional(InterventionExternalCode[externalCode]);

    const hideSampleMethod = (sampleMethods.length === 1 && sampleMethods[0].value === "NONE")
        || questionTest
        || noShowProduct;

    const selectMap: IndexSignature = {
      referralDoctorId: referralDoctorOptions
    }

    let insuranceDataValid = true;
    const checkInsuranceData = !invoicePrivate;
    if (checkInsuranceData) {
      insuranceDataValid = !!(patientData.ahvNumber && patientData.hasInsurance);
    }

    const referralDoctorField = selectInput(
        {
          name: 'referralDoctorId',
          input: {
            value: form.getState().values.referralDoctorId,
            onChange: (value: string) => {
              let referralDoctorId = null;
              let referralDoctor: DoctorDto | undefined = undefined;
              if (_.isNumber(value)) {
                referralDoctorId = parseInt(value);
                if (referralDoctorMap[referralDoctorId]) {
                  referralDoctor = referralDoctorMap[referralDoctorId];
                }
              }
              form.change("referralDoctorId", referralDoctorId);
              this.setState({
                missingDoctorEmail: !!(referralDoctor && !referralDoctor.email)
              });
            }
          },
          remoteSearch: true,
          remoteSearchMethod: this.searchDoctors,
          searchResultToOptionMapper: this.mapDoctors,
          clearable: true,
          options: referralDoctorOptions
        },
        selectMap
    );

    return <CheckInOutDiv id="checkInOutContent">
      <div className="header">
        {
            isCheckIn &&
            <StyledIcon>
              <Popup
                  trigger={
                    <ToolbarButton iconName="search"
                                   iconSize="large"
                                   onClick={() => this.triggerUpdatePatientFromHealthCard(bookingInTransition.patientId)}
                                   customTrigger={(
                                       <Icon.Group size="large">
                                         <Icon name="id card outline" color="grey"/>
                                       </Icon.Group>
                                   )}
                                   dataTooltip={getMessage('patient.toolbar.searchFromHealthCard')}
                                   disabled={!healthCardCheck}
                    />
                  }
                  open={healthCardPopupOpen}
                  popperDependencies={[!!healthCardPopupOpen]}
                  popperModifiers={{
                    preventOverflow: {
                      boundary: document.getElementById("checkInOutContent")
                    }
                  }}
                  content={this.renderUpdateFromHealthCardPopupContent()}
                  on="click"
                  onOpen={() => {
                  }}
                  onClose={() => this.closeUpdateFromHealthCardPopup()}
                  size="small"
                  position="bottom center"
              />
            </StyledIcon>
        }
      </div>

      <div className="form-content">
        <Grid>
          {
              updateSuccess &&
              <Grid.Row>
                <Grid.Column width={16}>
                  <Message success onDismiss={() => this.setState({updateSuccess: false})}>
                    <p>
                      {getMessage("patientCentral.checkIn.updateSuccess")}
                    </p>
                  </Message>
                </Grid.Column>
              </Grid.Row>
          }
          {
              !healthCardCheck &&
              <Grid.Row>
                <Grid.Column width={16}>
                  <Message warning>
                    <p>
                      {getMessage("patientCentral.checkIn.dataNotMatch")}
                      <Button
                          type="button"
                          className="update-btn"
                          compact
                          onClick={() => this.triggerUpdatePatientFromHealthCard(bookingInTransition.patientId)}
                      >
                        {getMessage("patientCentral.checkIn.updatePatientData")}
                      </Button>
                    </p>
                  </Message>
                </Grid.Column>
              </Grid.Row>
          }

          <Grid.Row>
            <Grid.Column className="no-padding" width={8}>
              <PxGrid>
                <Grid.Row>
                  <Grid.Column width={6}>
                    <b>{getMessage("patient")}:</b>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    <div className={"patient-data-container"}>
                      <span>{patientData.firstName} {patientData.name}</span>
                      {this.state.transitionMode === "checkIn" &&
                          <Icon name={'edit'} color={'grey'}
                                onClick={() => this.openPatientModal(bookingInTransition.patientId)}/>
                      }
                    </div>
                    {
                        !healthCardCheck && checkHealthCardData !== undefined &&
                        <div className="different-data">
                          {checkHealthCardData.firstName} {checkHealthCardData.name}
                        </div>
                    }
                    <div>{isoToDisplayDate(patientData.birthDate)} ({patientData.patientAge})</div>
                    {
                        !healthCardCheck && checkHealthCardData !== undefined &&
                        <div className="different-data">
                          {isoToDisplayDate(checkHealthCardData.birthDate)}
                        </div>
                    }
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={6}>
                    <b>{getMessage("company.title")}:</b>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    {patientData.companyDescription || ""}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={6}>
                    <b>{getMessage("company.container")}:</b>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    {patientData.containerDescription || ""}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={6}>
                    <b>{getMessage("email")}:</b>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    <div className={"patient-data-container"}>
                      <span title={"Patient email"}>{patientData.companyEmail || "n/a"}</span>
                      <Icon name={'edit'}
                            color={'grey'}
                            onClick={() => form.change("changeEmail", !form.getState().values.changeEmail)}/>
                    </div>

                    {
                        form.getState().values.changeEmail &&
                        <div className="email-field">
                          <Field
                              id="companyEmail"
                              name="companyEmail"
                              component={Input}
                              clearable
                              validate={emailValidator}
                          >
                            {({input, meta}) => (
                                <>
                                  <Input
                                      input={input}
                                      className="fluid"
                                      autoComplete="off"
                                      meta={meta}
                                  />
                                  {
                                      meta.error && meta.touched &&
                                      <span className="field-error">
                                                {getMessage(`testKitRegistration.error.${meta.error}`)}
                                            </span>}
                                </>
                            )}
                          </Field>
                        </div>
                    }
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={6}>
                    <b>{getMessage("patientCentral.overview.search.inputChannel")}:</b>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    {inputChannelDisplay}
                  </Grid.Column>
                </Grid.Row>
              </PxGrid>
            </Grid.Column>

            <Grid.Column className="no-padding" width={8}>
              <PxGrid>
                <Grid.Row>
                  <Grid.Column width={6}>
                    <b>{getMessage("insurance")}:</b>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    <div>{patientData.guarantorName ? patientData.guarantorName : ""}</div>
                    <div>{patientData.guarantorCity ? patientData.guarantorCity : ""}</div>
                    {
                        !healthCardCheck && checkHealthCardData !== undefined &&
                        <>
                          <div className="different-data">
                            {checkHealthCardData.guarantorName}
                          </div>
                        </>
                    }
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={6}>
                    <b>{getMessage("patientCentral.checkIn.ahvNumber")}:</b>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    {patientData.ahvNumber}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={6}>
                    <b>{getMessage("address")}:</b>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    <div>{patientData.street ? patientData.street : ""}</div>
                    <div>
                      {patientData.zip ? `${patientData.zip},` : ""} {patientData.city ? patientData.city : ""}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </PxGrid>
            </Grid.Column>
          </Grid.Row>
          {
              !insuranceDataValid &&
              <Grid.Row>
                <Grid.Column width={16}>
                  <Icon name="warning sign" color="red" size="small"/>
                  <span style={{color: "darkred"}}>
                    {getMessage("patientCentral.checkIn.incompleteInsurance.message")}
                  </span>
                </Grid.Column>
              </Grid.Row>
          }

          <Grid.Row style={{...RowStyles}}>
            <Grid.Column width={3}>
              {getMessage("anamnesis.form.treatment.referralDoctorId")}:
            </Grid.Column>
            <Grid.Column width={8}>
              <Field fluid {...referralDoctorField} />
              {this.state.missingDoctorEmail &&
                  <div className="doctor-email-warning">
                    <Icon name="warning sign"/>
                    {getMessage("anamnesis.form.missingDoctorEmail")}
                  </div>
              }
            </Grid.Column>
            {values.referralDoctorId &&
                <Grid.Column width={2}>
                  <Button type="button"
                          primary
                          size="mini"
                          onClick={() => this.openEditDoctorModal(values.referralDoctorId)}
                  >
                    {getMessage("msgEdit")}
                  </Button>
                </Grid.Column>
            }
          </Grid.Row>

          <Grid.Row style={{...RowStyles}}>
            {
                labTest && !testKitCodeHidden &&
                <>
                  <Grid.Column width={3}>
                    {getMessage("patientRecord.testResult.testKitCode")}:
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Field
                        id="testkitCode"
                        name="testkitCode"
                        component={Input}
                        clearable
                        validate={testkitCodeOptional ? validBarCode : composeValidators(required, validBarCode)}
                    >
                      {({input, meta}) => (
                          <>
                            <Input
                                // id="code"
                                input={input}
                                className="fluid"
                                /*onPaste={(evt: any) => {
                                  evt.preventDefault();
                                  evt.stopPropagation();
                                }}
                                onDrop={(evt: any) => {
                                  evt.preventDefault();
                                  evt.stopPropagation();
                                }}*/
                                autoComplete="off"
                                meta={meta}
                            />
                            {
                                meta.error && meta.touched &&
                                <span className="field-error">
                                                {getMessage(`testKitRegistration.error.${meta.error}`)}
                                            </span>}
                          </>
                      )}
                    </Field>
                  </Grid.Column>
                </>
            }
          </Grid.Row>

          {
              !hideSampleMethod &&
              <Grid.Row>
                <Grid.Column width={3} className="radio-group">
                  <div className="field-label">
                    <span className="inline-span">{getMessage("testSampleMethod")}:</span>
                  </div>
                </Grid.Column>
                <Grid.Column width={13} className="radio-group">
                  <Field
                      name="testSampleMethod"
                      component={RadioGroup}
                      radioDefinitions={sampleMethods}
                      fluid
                      radiowidth="auto"
                      validate={required}
                  />
                </Grid.Column>
              </Grid.Row>
          }

          {
              rapidTest &&
              <Grid.Row style={{...RapidTestCodeRowStyles}}>
                <Grid.Column width={3}>
                  {getMessage("patientCentral.checkIn.rapidTestCode")}:
                </Grid.Column>
                <Grid.Column width={8}>
                  <Field
                      name="rapidTestCode"
                      component={Select}
                      options={rapidTestCodeOptions}
                      fluid
                      clearable
                  />
                </Grid.Column>
              </Grid.Row>
          }

          {
              (testCheckInData!.orderItem) &&
              <Grid.Row>
                <Grid.Column width={3}>
                  {getMessage("anamnesis.form.orderItemId")}:
                </Grid.Column>
                <Grid.Column width={8}>
                  <div>
                    <span>{testCheckInData!.orderItem.name}</span>
                    <Icon name={'edit'}
                          color={'grey'}
                          onClick={() => {
                            this.setState({orderItemEditModalOpen: true});
                          }}
                    />
                  </div>

                  {
                      this.state.orderItemEditModalOpen &&
                      <UpsertOrderItemInstance
                          open={true}
                          orderItemInstance={this.state.testCheckInData!.orderItem}
                          selectedPanelIds={values.orderItemComponentIds}
                          close={() => {
                            this.setState({orderItemEditModalOpen: false});
                          }}
                          onSave={(selectedPanelIds: number[]) => {
                            form.change("orderItemComponentIds", selectedPanelIds);
                          }}
                      />
                  }
                </Grid.Column>
              </Grid.Row>
          }

          <Grid.Row>
            <Grid.Column width={3}>
              {getMessage("anamnesis.form.productId")}:
            </Grid.Column>
            <Grid.Column width={8}>
              <Field
                  name="productId"
                  component={Select}
                  options={productOptions}
                  fluid
              />
            </Grid.Column>
          </Grid.Row>
          {
            !freeProduct
                ? <Grid.Row>
                  <Grid.Column width={3}>
                    {getMessage("anamnesis.form.amountInsurance")}:
                  </Grid.Column>
                  <Grid.Column width={2}>
                    {
                        interventionPriceInsurance !== undefined &&
                        <span>{interventionPriceInsurance}&nbsp;CHF</span>
                    }
                  </Grid.Column>

                  <Grid.Column width={3}>
                    {getMessage("anamnesis.form.amountPatient")}:
                  </Grid.Column>
                  <Grid.Column width={2}>
                    {
                        interventionPriceInsurance !== undefined &&
                        <span>{interventionPricePatient}&nbsp;CHF</span>
                    }
                  </Grid.Column>
                </Grid.Row>
                : <Grid.Row>
                  <Grid.Column>
                          <span style={{fontStyle: "italic", color: "#0096FF"}}>
                            {getMessage("product.freeProduct.message")}
                          </span>
                  </Grid.Column>
                </Grid.Row>
          }

          {
              !freeProduct &&
              <Grid.Row style={{...RapidTestCodeRowStyles}}>
                <Grid.Column width={3}>
                  {getMessage("patientCentral.checkIn.paymentMethod")}:
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                      name="inkasso"
                      component={Select}
                      validate={required}
                      options={filteredPaymentMethods}
                      fluid
                      disabled={disabledInkasso}
                  />
                </Grid.Column>
                {
                    showCreditCardDigits &&
                    <Grid.Column width={2}>
                      <Field
                          name="creditCardDigits"
                          component={Input}
                          placeholder="####"
                          validate={ccdValidator}
                          parse={this.parseCreditCardDigitsInput}
                          fluid
                      />
                    </Grid.Column>
                }
                {
                    showTwintTransactionId &&
                    <Grid.Column width={4}>
                      <Field
                          name="twintTransactionId"
                          component={Input}
                          placeholder="000022A2555H7777"
                          validate={twintTransactionIdValidator}
                          parse={this.parseTwintTransactionIdDigitsInput}
                          fluid
                      />
                    </Grid.Column>
                }
                {
                    inkassoWarning &&
                    <Grid.Column width={8}>
                      <div className="inkasso-warn">
                        <Icon name="warning sign" color="brown"/>
                        {getMessage("patientCentral.checkIn.warning.inkassoWarning")}
                      </div>
                    </Grid.Column>
                }
              </Grid.Row>
          }

          {
              showExpectedDateTime &&
              <Grid.Row>
                <Grid.Column width={3}>
                  {getMessage("patientCentral.checkIn.expectedResultDate")}:
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                      name="expectedResultDate"
                      component={DatePicker}
                      disabledBefore={disabledExpResDateBefore}
                      emptyDateInput
                      fluid
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                  {getMessage("patientCentral.checkIn.expectedResultTime")}:
                </Grid.Column>
                <Grid.Column width={3}>
                  <Field
                      name="expectedResultTime"
                      component={TimeInput}
                      size="small"
                      fluid
                  />
                </Grid.Column>
              </Grid.Row>
          }

          <Grid.Row>
            <Grid.Column width={3}>
              {getMessage("patientCentral.checkIn.urgency")}:
            </Grid.Column>
            <Grid.Column width={8}>
              <Field
                  name="urgency"
                  component={Select}
                  validate={required}
                  options={urgencyOptions}
                  disabled={true}
                  fluid
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={3}>
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                  name="generateCertificate"
                  component={CheckBox}
                  label={getMessage("patientCentral.checkIn.generateCertificate")}
                  disabled={true}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                  name="generateReport"
                  component={CheckBox}
                  label={getMessage("patientCentral.checkIn.generateReport")}
                  disabled={true}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={3}>
              {getMessage("anamnesis.form.treatment.remarks")}:
            </Grid.Column>
            <Grid.Column width={8}>
              <Field name="remarks"
                     component={TextArea}
                     rows={2}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      <div className="actions-row">
        <Button type="button"
                compact
                primary
                onClick={(evt) => handleSubmit(evt as any)}
                disabled={!insuranceDataValid}
        >
          {getMessage("button.save")}
        </Button>

        <Button type="button" compact onClick={this.props.onCancel}>
          {getMessage("button.cancel")}
        </Button>

        {
            this.state.submitError &&
            <div className="submit-error">
              {getMessage(this.state.submitError)}
            </div>
        }

        {
            this.state.submitWarning &&
            <div className="submit-warn">
              {getMessage(this.state.submitWarning)}
            </div>
        }
      </div>

      <FormSpy
          subscription={{values: true, hasValidationErrors: true}}
          onChange={this.onFormChange}
      />
    </CheckInOutDiv>;
  }

  renderUpdateFromHealthCardPopupContent = () => {
    const {getMessage} = this.props;
    const {healthCardPopupStatus} = this.state;

    let content = () => {
      switch (healthCardPopupStatus) {
        case CardReaderState.INITIAL :
          return <InfoDiv>
            <div className="info-message minimal-info-message">
              {getMessage('patient.searchFromHealthCardPopup.state.initial')}
            </div>
          </InfoDiv>;

        case CardReaderState.NO_EXTENSION :
          return <InfoDiv>
            <div className="info-message">
              {getMessage('nativeTools.status.NO_EXTENSION')}
              <div className="download-link">
                <a href="https://chrome.google.com/webstore/detail/iggeppehjnmjeeicldkpjopdofglljei?authuser=0&hl=en"
                   target="_blank">{getMessage('nativeTools.download.chromeExtension')}</a>
              </div>
            </div>
          </InfoDiv>;

        case CardReaderState.OUTDATED_EXTENSION :
          return <InfoDiv>
            <div className="info-message">
              {getMessage('nativeTools.status.OUTDATED_EXTENSION')}
              <div className="download-link">
                <a href="https://praxmedic.ch/native-tools" target="_blank">
                  {getMessage('nativeTools.download.chromeExtension')}
                </a>
              </div>
            </div>
          </InfoDiv>;

        case CardReaderState.NO_HOST_APPLICATION :
          return <InfoDiv>
            <div className="info-message">
              {getMessage('nativeTools.status.NO_HOST_APPLICATION')}
              <div className="download-link">
                <a href="https://praxmedic.ch/native-tools" target="_blank">
                  {getMessage('nativeTools.download.hostApplication')}
                </a>
              </div>
            </div>
          </InfoDiv>;

        case CardReaderState.OUTDATED_HOST_APP :
          return <InfoDiv>
            <div className="info-message">
              {getMessage('nativeTools.status.OUTDATED_HOST_APP')}
              <div className="download-link">
                <a href="https://praxmedic.ch/native-tools" target="_blank">
                  {getMessage('nativeTools.download.hostApplication')}
                </a>
              </div>
            </div>
          </InfoDiv>;

        case CardReaderState.NO_CARD :
          return <InfoDiv>
            <div className="info-message minimal-info-message">
              {getMessage('patient.searchFromHealthCardPopup.state.noCard')}
            </div>
          </InfoDiv>;
      }
    }

    return (
        <div>
          {content()}
          <div>
            <Button type="button" compact onClick={this.closeUpdateFromHealthCardPopup}>
              {getMessage("button.close")}
            </Button>
          </div>
        </div>
    )
  };

  renderUpsertPatient = (): React.ReactNode => {

    const {patientModalOpen, patient, patientId, countries, languages} = this.state;
    const {currentMandates, getAllMandates} = this.props;

    return (
        <>
          {patientModalOpen &&
              <UpsertPatient
                  modalOpen={patientModalOpen}
                  toggleModal={this.togglePatientModal}
                  patient={patient}
                  patientId={patientId}
                  countries={countries}
                  languages={languages}
                  currentMandates={currentMandates}
                  getAllMandates={getAllMandates}
                  onPatientSave={this.onPatientSave}
              />
          }
        </>
    );
  };

  openPatientModal = (patientId: number) => {

    this.setState({patientLoading: true});
    findPatientById(this.cancelTokenSource, patientId)
        .then(response => {
          this.setState({
            patientId: patientId,
            patient: response
          });
          this.togglePatientModal();
        })
        .catch(noop)
        .finally(() => this.setState({patientLoading: false}));
  };

  onPatientSave = async (patient: PatientDto) => {
    const {bookingInTransition} = this.props;
    const patientData: PatientDataResponseDto = await getPatientData(bookingInTransition.patientId, this.cancelTokenSource)

    this.setState({
      patientData: patientData
    });
    this.togglePatientModal();
  }

  togglePatientModal = () => {
    this.setState(({patientModalOpen}: State) => ({
      patientModalOpen: !patientModalOpen
    }));
  };

  onSaveDoctor = () => {
    const {doctorId} = this.state;
    if (doctorId) {
      this.fetchSpecificReferralDoctor(doctorId);
    }
    this.hideDoctorModal();
  };

  openEditDoctorModal = (id: number | undefined) => {
    if (id) {
      findDoctorById(id, this.cancelTokenSource).then(response => {
        this.showDoctorModal(id, response);
      }).catch(noop);
    }
  };

  showDoctorModal = (id?: number, doctor?: UpsertDoctorDto) => {

    this.setState(({}: State) => {
      return {
        editDoctorModalOpen: true,
        doctor: doctor,
        doctorId: id
      }
    });
  };

  hideDoctorModal = () => {

    this.setState(({}: State) => ({
      editDoctorModalOpen: false,
      doctorId: undefined,
      doctor: undefined
    }));
  };

  renderUpsertDoctorModal = (): React.ReactNode => {

    const {getMessage} = this.props;
    const {editDoctorModalOpen, doctor, doctorId} = this.state;

    return (
        <Modal
            open={editDoctorModalOpen}
            onClose={() => this.hideDoctorModal()}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("doctors")}</Modal.Header>
          <FormModalContentContainer>
            <UpsertDoctorForm
                doctor={doctor}
                doctorId={doctorId}
                onSave={this.onSaveDoctor}
                onCancel={this.hideDoctorModal}
            />
          </FormModalContentContainer>
        </Modal>
    );
  };

}

export default withMessages(
    withAuthContext(
        withPatientCentralRefDataContext(
            withPatientCentralContext(
                withMandateContext(TestTransitionForm)))));
